module.exports = __webpack_public_path__ + "img/239.68cd7f5e.png";